import { activityConstants } from "../_constants";
import { activityService } from "../_services";
//import { history } from '../_helpers';

export const activityActions = {
  getDailyDetail,
  getWeeklyDetail,
  getOffDayAlerts,
  setActivityFrequency,
  setDetailItem,
  getTimeline,
  setDailyOffAlertsToggle,
  setWeeklyOffAlertsToggle,
};

function getTimeline(user, timestamp) {
  return (dispatch) => {
    dispatch(request());

    activityService.getTimeline(user, timestamp).then(
      (detail) => {
        dispatch(success(detail));
      },
      (error) => {
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: activityConstants.TIMELINE_REQUEST };
  }
  function success(detail) {
    return { type: activityConstants.TIMELINE_SUCCESS, detail };
  }
  function failure(error) {
    return { type: activityConstants.TIMELINE_FAILURE, error };
  }
}

function getOffDayAlerts(user, timestamp) {
  return (dispatch) => {
    dispatch(request());

    activityService.getOffDayAlerts(user, timestamp).then(
      (detail) => {
        dispatch(success(detail));
      },
      (error) => {
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: activityConstants.OFF_ALERTS_REQUEST };
  }
  function success(detail) {
    return { type: activityConstants.OFF_ALERTS_SUCCESS, detail };
  }
  function failure(error) {
    return { type: activityConstants.OFF_ALERTS_FAILURE, error };
  }
}

function getDailyDetail(user, timestamp) {
  return (dispatch) => {
    dispatch(request());

    activityService.getDailyDetail(user, timestamp).then(
      (detail) => {
        dispatch(success(detail));
      },
      (error) => {
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: activityConstants.DAILY_STATUS_REQUEST };
  }
  function success(detail) {
    return { type: activityConstants.DAILY_STATUS_SUCCESS, detail };
  }
  function failure(error) {
    return { type: activityConstants.DAILY_STATUS_FAILURE, error };
  }
}

function getWeeklyDetail(user, timestamp) {
  return (dispatch) => {
    dispatch(request());

    activityService.getWeeklyDetail(user, timestamp).then(
      (detail) => {
        dispatch(success(detail));
      },
      (error) => {
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: activityConstants.WEEKLY_STATUS_REQUEST };
  }
  function success(detail) {
    return { type: activityConstants.WEEKLY_STATUS_SUCCESS, detail };
  }
  function failure(error) {
    return { type: activityConstants.WEEKLY_STATUS_FAILURE, error };
  }
}

function setActivityFrequency(timescale) {
  return (dispatch) => {
    dispatch(setFrequency(timescale));
  };

  function setFrequency(timescale) {
    return { type: activityConstants.SET_ACTIVITY_FREQUENCY, timescale };
  }
}

function setDetailItem(item) {
  return (dispatch) => {
    dispatch(setItem(item));
  };

  function setItem(item) {
    return { type: activityConstants.SET_DETAIL_ITEM, item };
  }
}

function setDailyOffAlertsToggle(state) {
  return (dispatch) => {
    dispatch(setItem(state));
  };

  function setItem(state) {
    return { type: activityConstants.SET_DAILY_OFF_ALERTS_TOGGLE, state };
  }
}
function setWeeklyOffAlertsToggle(state) {
  return (dispatch) => {
    dispatch(setItem(state));
  };

  function setItem(state) {
    return { type: activityConstants.SET_WEEKLY_OFF_ALERTS_TOGGLE, state };
  }
}
